module.exports = __webpack_public_path__ + "static/media/odejmowanie_w_zakresie_30_rozpisywanie.143d8ec7.pdf";